import { HubConnection } from '@microsoft/signalr';
import { debounce } from 'lodash';

import { SignalRDefaultDebounceOptions, SignalRDefaultDebounceTimeout } from '../../../../../Config';
import { store } from '../../../../../shared/store';
import { PostAcutePaths } from '../../../../paths';
import { fetchNewAdmits } from '../slice';

const handleRefresh = async () => {
    // Only reload if the user is currently on the new admits page
    if (window.location.pathname === PostAcutePaths.NewAdmits.Index) {
        await store.dispatch(fetchNewAdmits());
    }
};

const onPatientIntakeAdded = debounce(
    async () => {
        await handleRefresh();
    },
    SignalRDefaultDebounceTimeout,
    SignalRDefaultDebounceOptions
);

const onPatientIntakeUpdated = debounce(
    async () => {
        await handleRefresh();
    },
    SignalRDefaultDebounceTimeout,
    SignalRDefaultDebounceOptions
);

const onPatientIntakeDischarged = debounce(
    async () => {
        await handleRefresh();
    },
    SignalRDefaultDebounceTimeout,
    SignalRDefaultDebounceOptions
);

export const removeNewAdmitsHubConnection = (connection: HubConnection) => {
    connection.off('PatientIntakeAdded', onPatientIntakeAdded);
    connection.off('PatientIntakeUpdated', onPatientIntakeUpdated);
    connection.off('PatientIntakeDischarged', onPatientIntakeDischarged);
};

export const initNewAdmitsHubConnection = (connection: HubConnection) => {
    connection.on('PatientIntakeAdded', onPatientIntakeAdded);
    connection.on('PatientIntakeUpdated', onPatientIntakeUpdated);
    connection.on('PatientIntakeDischarged', onPatientIntakeDischarged);
};
